import { AtomIcon, HardHatIcon, MagnetIcon, PlugIcon, SettingsIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Hydrogen Energy Fundamentals & Technical Principles',
    summary: 'Introduction, physical/chemical properties, energy principles, production pathways, hydrogen in energy systems, technological basics.',
    icon: WrenchIcon,
  },
  {
    number: '2',
    title: 'Hydrogen Production & Electrolysis Technologies',
    summary: 'Conventional production, water electrolysis, alkaline/PEM/advanced technologies, renewable hydrogen, efficiency, economics.',
    icon: SettingsIcon,
  },
  {
    number: '3',
    title: 'Hydrogen Storage, Transportation & Infrastructure',
    summary: 'Storage technologies, compression, liquefaction, advanced storage, pipelines, distribution networks, material compatibility.',
    icon: MagnetIcon,
  },
  {
    number: '4',
    title: 'Fuel Cell Technologies & Power Generation Systems',
    summary: 'Electrochemistry, PEMFC/SOFC/other technologies, stacks, performance, durability, applications, economics.',
    icon: AtomIcon,
  },
  {
    number: '5',
    title: 'Hydrogen Systems Integration & Industrial Applications',
    summary: 'Sector coupling, renewable integration, oil/gas, chemicals, steelmaking, transportation, power generation, hydrogen hubs.',
    icon: PlugIcon,
  },
  {
    number: '6',
    title: 'Hydrogen Safety, System Reliability & Future Technologies',
    summary: 'Safety fundamentals, hazards, risk management, material reliability, maintenance, international standards, emerging innovations.',
    icon: HardHatIcon,
  },
];
